import { View } from "binder"
import { ToolPlaceManipulationViewModel, ToolPlaceHolderType } from "./toolPlaceManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ToolPlaceManipulationView extends View<ToolPlaceManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-22860E77-658B-4FC4-A8ED-D417DC5E56CE"
    }
    loadHtml(): string {
        let element = require('./toolPlaceManipulation.html').default;
        let style = require('./toolPlaceManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolPlaces(v: ToolPlaceHolderType) { this._toolPlaces = v; } public get toolPlaces(): ToolPlaceHolderType { return this._toolPlaces; } private _toolPlaces: ToolPlaceHolderType;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;
}
